import React from 'react';
import { TextCollectionParams } from '@scale/shared/types/params/textcollection';
import { TextCollectionResponse } from '@scale/shared/types/response/textcollection';
import SimpleTextCollectionForm from './SimpleTextCollectionForm';
import { DocumentProvider } from 'react-scale/components/scalers/tasks/textcollection/document';
import { ChatTaskBehaviorLogMetadata } from '@scale/shared/types/chat';
import { ChatMessageDisplayConfig } from '../../ThreadedInteraction/hooks/useConfigureChatMessageDisplay';
import { CodingUnitTestsGenerationConfig } from 'react-scale/components/scalers/tasks/textcollection/SimpleTextCollection/UnitTestsGenerationForm';

interface SimpleTextCollectionCoreProps {
  assignmentId?: string;
  readOnly?: boolean;
  params: TextCollectionParams;
  response: TextCollectionResponse;
  setResponse: (response: TextCollectionResponse) => void;
  setSubmitCodeError?: (field_id: string, error: string) => void;
  chatTaskBehaviorLogMetadata?: ChatTaskBehaviorLogMetadata;
  readOnlyMessage?: string;
  chatMessageDisplayConfig?: ChatMessageDisplayConfig;
  codingUnitTestsGenerationConfig?: CodingUnitTestsGenerationConfig;
  projectId?: string;
  lastPrompt?: string | null;
  lastModelResponseEditorContent?: string | null;
}

export const SimpleTextCollectionCore: React.FC<SimpleTextCollectionCoreProps> = props => {
  return (
    <DocumentProvider attachments={0} fields={props.params.fields}>
      <div className="flex flex-1 flex-row relative h-full">
        <div className="!w-full" style={{ borderLeft: 'none !important' }}>
          <SimpleTextCollectionForm
            title={props.params.title}
            description={props.params.description}
            fields={props.params.fields}
            annotations={props.response?.annotations}
            setAnnotations={annotations => {
              props.setResponse({
                ...props.response,
                annotations:
                  typeof annotations === 'function'
                    ? annotations(props.response.annotations)
                    : annotations,
              });
            }}
            readOnly={!!props.readOnly}
            setSubmitCodeError={props.setSubmitCodeError}
            assignmentId={props.assignmentId}
            chatTaskBehaviorLogMetadata={props.chatTaskBehaviorLogMetadata}
            readOnlyMessage={props.readOnlyMessage}
            templateVariables={props.params.templateVariables}
            chatMessageDisplayConfig={props.chatMessageDisplayConfig}
            codingUnitTestsGenerationConfig={props.codingUnitTestsGenerationConfig}
            projectId={props.projectId}
            lastPrompt={props.lastPrompt}
            lastModelResponseEditorContent={props.lastModelResponseEditorContent}
            enableRTLText={props.params.enable_rtl_text}
          />
        </div>
      </div>
    </DocumentProvider>
  );
};
